import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import { MathfieldElement } from 'mathlive';
import styled from 'styled-components';
import { styleVariables } from '../../../style';
import { EditOutlined } from '@ant-design/icons';
import { getColor } from '../../../hooks';
import { SecondaryButton } from '../../../components/button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var MathSymbols = function MathSymbols(_ref) {
  var onSelectSymbol = _ref.onSelectSymbol;

  var _useState = useState(''),
      searchTerm = _useState[0];

  var commonSymbols = [{
    label: '+',
    value: '+'
  }, {
    label: '-',
    value: '-'
  }, {
    label: '\\pm',
    value: '\\pm'
  }, {
    label: '\\times',
    value: '\\times'
  }, {
    label: '\\div',
    value: '\\div'
  }, {
    label: '=',
    value: '='
  }, {
    label: '\\neq',
    value: '\\neq'
  }, {
    label: '>',
    value: '>'
  }, {
    label: '<',
    value: '<'
  }, {
    label: '\\geq',
    value: '\\geq'
  }, {
    label: '\\leq',
    value: '\\leq'
  }, {
    label: '\\frac{a}{b}',
    value: '\\frac{a}{b}'
  }, {
    label: 'a^b',
    value: 'a^b'
  }, {
    label: 'a_b',
    value: 'a_{b}'
  }, {
    label: '\\sqrt{x}',
    value: '\\sqrt{x}'
  }, {
    label: '\\sqrt[n]{x}',
    value: '\\sqrt[n]{x}'
  }, {
    label: '\\sum_{i=1}^{n}',
    value: '\\sum_{i=1}^{n}'
  }, {
    label: '\\int_{a}^{b}',
    value: '\\int_{a}^{b}'
  }, {
    label: '\\prod_{i=1}^{n}',
    value: '\\prod_{i=1}^{n}'
  }, {
    label: '\\lim_{x \\to a}',
    value: '\\lim_{x \\to a}'
  }, {
    label: '\\infty',
    value: '\\infty'
  }, {
    label: '\\pi',
    value: '\\pi'
  }, {
    label: '\\alpha',
    value: '\\alpha'
  }, {
    label: '\\beta',
    value: '\\beta'
  }, {
    label: '\\gamma',
    value: '\\gamma'
  }, {
    label: '\\Delta',
    value: '\\Delta'
  }, {
    label: '\\Sigma',
    value: '\\Sigma'
  }, {
    label: '\\Omega',
    value: '\\Omega'
  }, {
    label: '\\partial',
    value: '\\partial'
  }, {
    label: '\\nabla',
    value: '\\nabla'
  }];
  var symbolGroups = [{
    name: 'Ký hiệu phổ biến',
    symbols: commonSymbols,
    id: 'common'
  }];
  var filteredSymbolGroups = symbolGroups.map(function (group) {
    return _objectSpread(_objectSpread({}, group), {}, {
      symbols: group.symbols.filter(function (symbol) {
        return symbol.label.toLowerCase().includes(searchTerm.toLowerCase()) || symbol.value.toLowerCase().includes(searchTerm.toLowerCase());
      })
    });
  }).filter(function (group) {
    return group.symbols.length > 0;
  });
  useEffect(function () {
    var ensureMathLive = function ensureMathLive() {
      if (typeof MathfieldElement !== 'undefined') {
        var globalMfe = new MathfieldElement();
        globalMfe.style.display = 'none';
        globalMfe.setAttribute('fonts-directory', 'https://unpkg.com/mathlive/dist/fonts');
        globalMfe.setAttribute('letter-shape-style', 'tex');
        globalMfe.setAttribute('font-size', '20px');
        globalMfe.setAttribute('math-mode-space', '1em');
        globalMfe.setAttribute('math-style', 'normal');
        globalMfe.setAttribute('min-font-scale', '0.8');
        globalMfe.setAttribute('smart-fence', 'true');
        globalMfe.setAttribute('smart-superscript', 'true');
        globalMfe.setAttribute('letter-spacing', '0.5px');
        document.body.appendChild(globalMfe);
        setTimeout(function () {
          try {
            document.body.removeChild(globalMfe);
          } catch (e) {
            console.error('Error removing temporary mathfield:', e);
          }
        }, 500);
      }
    };

    ensureMathLive();

    if (!document.getElementById('math-symbols-styles')) {
      var styleElement = document.createElement('style');
      styleElement.id = 'math-symbols-styles';
      styleElement.textContent = "\n        .symbol-content math-field {\n          pointer-events: none !important;\n          border: none !important;\n          background: transparent !important;\n          padding: 0 !important;\n          margin: 0 !important;\n          font-size: 20px !important;\n          width: 100% !important;\n          height: 100% !important;\n          display: flex !important;\n          align-items: center !important;\n          justify-content: center !important;\n          letter-spacing: 0.5px !important;\n        }\n        \n        .symbol-content {\n          cursor: pointer;\n          width: 100%;\n          height: 100%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          position: relative;\n          z-index: 1;\n        }\n        \n        .latex-symbol-container {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          width: 100%;\n          height: 100%;\n          min-height: 30px;\n          pointer-events: none;\n        }\n        \n        math-field {\n          --hue: 210;\n          --highlight-color: hsla(var(--hue), 97%, 85%, 0.5);\n          --font-family: 'Latin Modern Math', 'Cambria Math', math;\n          --smart-fence: true;\n          --smart-superscript: true;\n          font-kerning: normal;\n          text-rendering: optimizeLegibility;\n          --math-mode-space: 1em !important;\n          letter-spacing: 0.5px !important;\n        }\n      ";
      document.head.appendChild(styleElement);
    }
  }, []);
  return /*#__PURE__*/_jsx(SymbolsContainer, {
    children: /*#__PURE__*/_jsx(SymbolGroups, {
      children: /*#__PURE__*/_jsx(SymbolsGrid, {
        children: filteredSymbolGroups.flatMap(function (group) {
          return group.symbols.map(function (symbol, symbolIndex) {
            var isComplexFormula = symbol.label.length > 5 || symbol.label.includes('\\frac') || symbol.label.includes('\\sqrt') || symbol.label.includes('\\int') || symbol.label.includes('matrix');
            return /*#__PURE__*/_jsx(SymbolButton, {
              onClick: function onClick() {
                return onSelectSymbol(symbol.value);
              },
              title: symbol.value,
              complex: isComplexFormula,
              children: /*#__PURE__*/_jsx("div", {
                className: "symbol-content",
                onClick: function onClick(e) {
                  e.preventDefault();
                  e.stopPropagation();
                  onSelectSymbol(symbol.value);
                },
                children: /*#__PURE__*/_jsx(LatexSymbol, {
                  latex: symbol.value
                })
              })
            }, "".concat(group.id, "-").concat(symbolIndex));
          });
        })
      })
    })
  });
};

var SymbolsContainer = styled.div.withConfig({
  displayName: "math-node-view__SymbolsContainer",
  componentId: "sc-o6698n-0"
})(["background-color:", ";border:1px solid ", ";border-radius:8px;padding:18px;margin-top:10px;overflow-y:auto;max-height:400px;box-shadow:0 3px 10px ", ";"], getColor('fillBgWhite'), getColor('fillHighlight3'), getColor('fillIntSubActive'));
var SymbolGroups = styled.div.withConfig({
  displayName: "math-node-view__SymbolGroups",
  componentId: "sc-o6698n-1"
})(["display:flex;flex-direction:column;gap:8px;"]);
var SymbolsGrid = styled.div.withConfig({
  displayName: "math-node-view__SymbolsGrid",
  componentId: "sc-o6698n-2"
})(["display:grid;grid-template-columns:repeat(auto-fill,70px);gap:10px;padding:12px;justify-content:center;"]);
var SymbolButton = styled.button.withConfig({
  displayName: "math-node-view__SymbolButton",
  componentId: "sc-o6698n-3"
})(["width:70px;height:70px;border:1px solid ", ";background-color:", ";border-radius:6px;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:16px;transition:all 0.2s;padding:6px;position:relative;overflow:hidden;user-select:none;&:hover{background-color:", ";border-color:", ";z-index:1;}&:active{background-color:", ";}.latex-symbol-container{width:100%;height:100%;display:flex;align-items:center;justify-content:center;}.ML__container{margin:0 !important;}", ""], getColor('fillHighlight3'), getColor('fillBgWhite'), getColor('fillIntActive'), getColor('fillHighlight3'), getColor('fillIntActive'), function (props) {
  return props.complex ? "\n    .ML__container {\n      transform: scale(0.7);\n    }\n  " : "\n    .ML__container {\n      transform: scale(1.2);\n    }\n  ";
});
var MathModal = styled.div.withConfig({
  displayName: "math-node-view__MathModal",
  componentId: "sc-o6698n-4"
})(["position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(248,248,248,0.2);display:flex;justify-content:center;align-items:center;z-index:1000;overflow:hidden;backdrop-filter:blur(3px);transition:all 0.3s ease;"]);
var ModalContent = styled.div.withConfig({
  displayName: "math-node-view__ModalContent",
  componentId: "sc-o6698n-5"
})(["background-color:", ";border-radius:12px;box-shadow:0 8px 30px ", ";width:90%;max-width:750px;max-height:90vh;height:auto;display:flex;flex-direction:column;overflow:hidden;position:relative;isolation:isolate;animation:modalFadeIn 0.3s ease;border:1px solid ", ";@keyframes modalFadeIn{from{opacity:0;transform:translateY(-20px);}to{opacity:1;transform:translateY(0);}}@media (max-width:768px){width:95%;max-height:95vh;}"], getColor('fillBgWhite'), getColor('fillIntSubActive'), getColor('fillHighlight3'));
var ModalBody = styled.div.withConfig({
  displayName: "math-node-view__ModalBody",
  componentId: "sc-o6698n-6"
})(["padding:0 24px;flex:0 1 auto;overflow-y:auto;display:flex;flex-direction:column;position:relative;min-height:180px;scrollbar-width:thin;&::-webkit-scrollbar{width:8px;}&::-webkit-scrollbar-track{background:", ";border-radius:4px;}&::-webkit-scrollbar-thumb{background-color:", ";border-radius:4px;&:hover{background-color:", ";}}max-height:calc(80vh - 120px);"], getColor('fillHighlight3'), getColor('fillHighlight2'), getColor('fillHighlight2'));
var ModalFooter = styled.div.withConfig({
  displayName: "math-node-view__ModalFooter",
  componentId: "sc-o6698n-7"
})(["display:flex;justify-content:flex-end;gap:12px;padding:16px 24px;border-top:1px solid ", ";background-color:", ";position:relative;z-index:10002;box-shadow:0 -2px 10px ", ";"], getColor('fillHighlight3'), getColor('fillBgSub'), getColor('fillIntSubActive'));
var MathfieldContainer = styled.div.withConfig({
  displayName: "math-node-view__MathfieldContainer",
  componentId: "sc-o6698n-8"
})(["padding:20px;border:1px solid ", ";border-radius:8px;background-color:", ";min-height:100px;margin:24px 0 16px;flex:1;overflow-y:auto;transition:all 0.2s ease;box-shadow:0 2px 4px rgba(0,0,0,0.05);&:hover,&:focus-within{border-color:", ";box-shadow:0 0 0 3px ", ";}.ML__container{transition:all 0.2s ease;}.ML__fieldcontainer{min-height:60px;display:flex;align-items:center;justify-content:center;}"], getColor('fillHighlight3'), getColor('fillBgWhite'), getColor('fillIntActive'), getColor('fillIntActive'));
var MathContainer = styled.div.withConfig({
  displayName: "math-node-view__MathContainer",
  componentId: "sc-o6698n-9"
})(["position:relative;display:inline-block;padding:8px 12px;margin:2px;border:1px solid transparent;min-width:120px;min-height:30px;cursor:pointer;transition:all 0.2s ease;&:hover{background-color:", "33;}&.editing{border-color:", ";box-shadow:0 0 0 3px ", "22;background-color:", ";}&.selected{border-color:", ";}.ML__container{margin:4px 0;width:100%;display:flex;justify-content:center;}.math-actions{position:absolute;top:-20px;right:0;display:none;gap:4px;}&:hover .math-actions{display:flex;}.math-action-button{display:flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background-color:", ";border:1px solid ", ";cursor:pointer;transition:all 0.2s ease;padding:0;font-size:12px;&:hover{background-color:", ";border-color:", ";}}"], styleVariables.colors.blue1, styleVariables.colors.blue3, styleVariables.colors.blue3, styleVariables.colors.blue1, getColor('fillIntActive'), getColor('fillBgWhite'), getColor('fillHighlight3'), getColor('fillIntActive'), getColor('fillIntActive'));

var configureMathField = function configureMathField(mfe) {
  mfe.style.fontSize = '18px';
  mfe.style.width = '100%';
  mfe.style.minHeight = '50px';
  mfe.style.padding = '8px';
  mfe.style.backgroundColor = 'white';
  mfe.style.borderRadius = '4px';
  mfe.setAttribute('virtual-keyboard-layout', 'standard');
  mfe.setAttribute('virtual-keyboard-mode', 'off');
  mfe.setAttribute('virtual-keyboard-toggle', 'hidden');
  mfe.setAttribute('keypress-sound', 'none');
  mfe.setAttribute('fonts-directory', 'https://unpkg.com/mathlive/dist/fonts');
  mfe.setAttribute('smart-mode', 'true');
  mfe.setAttribute('smart-fence', 'true');
  mfe.setAttribute('math-mode-space', '\\,');
  mfe.setAttribute('default-mode', 'math');
  mfe.setAttribute('letter-shape-style', 'tex');

  if (!document.getElementById('math-keyboard-modal-styles')) {
    var styleElement = document.createElement('style');
    styleElement.id = 'math-keyboard-modal-styles';
    styleElement.textContent = "\n      .ML__keyboard {\n        z-index: 20 !important;\n        width: 100% !important;\n        position: static !important;\n        bottom: auto !important;\n        left: auto !important;\n        right: auto !important;\n        margin: 0 !important;\n        background-color: #f5f5f5 !important;\n        box-shadow: 0 -2px 10px rgba(0,0,0,0.1) !important;\n        transform: none !important;\n        transition: none !important;\n        max-width: 100% !important;\n        display: block !important;\n        visibility: visible !important;\n        opacity: 1 !important;\n      }\n      \n      .ML__keyboard .rows {\n        max-height: 180px !important;\n        overflow-y: auto !important;\n      }\n      \n      .ML__keyboard .ML__keyboard-key {\n        min-width: 34px !important;\n        height: 34px !important;\n        margin: 2px !important;\n        font-size: 14px !important;\n      }\n      \n      .ML__keyboard-layer {\n        max-height: 180px !important;\n        overflow-y: auto !important;\n      }\n      \n      #virtual-keyboard-container {\n        position: relative;\n        z-index: 20;\n        border-top: 1px solid #ddd;\n        background-color: #f5f5f5;\n        display: block !important;\n        overflow: visible !important;\n        min-height: 180px;\n      }\n      \n      #virtual-keyboard-container .ML__keyboard {\n        position: static !important;\n        width: 100% !important;\n        max-width: 100% !important;\n        margin: 0 !important;\n        transform: none !important;\n        display: block !important;\n        visibility: visible !important;\n        opacity: 1 !important;\n      }\n      \n      .ML__keyboard {\n        contain: content;\n      }\n      \n      .modal-mathfield-container {\n        padding-bottom: 0 !important;\n        margin-bottom: 0 !important;\n      }\n      \n      .ML__keyboard-toggle {\n        display: none !important;\n      }\n      \n      .symbol-content .ML__container {\n        margin: 0 !important;\n        display: flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n      }\n      \n      .latex-symbol-container math-field {\n        font-size: 16px !important;\n        line-height: 1 !important;\n        padding: 0 !important;\n        margin: 0 !important;\n        background: transparent !important;\n      }\n      \n      .latex-symbol-container .ML__base {\n        margin: 0 auto !important;\n      }\n    ";
    document.head.appendChild(styleElement);
  }

  return mfe;
};

var LatexSymbol = function LatexSymbol(_ref2) {
  var latex = _ref2.latex;
  var mfRef = useRef(null);
  useEffect(function () {
    if (mfRef.current) {
      while (mfRef.current.firstChild) {
        mfRef.current.removeChild(mfRef.current.firstChild);
      }

      var mfe = new MathfieldElement();
      mfe.value = latex;
      mfe.setAttribute('read-only', 'true');
      mfe.setAttribute('letter-shape-style', 'tex');
      mfe.setAttribute('font-size', '22px');
      mfe.setAttribute('smart-fence', 'true');
      mfe.setAttribute('smart-superscript', 'true');
      mfe.setAttribute('math-mode-space', '1em');
      mfe.setAttribute('letter-spacing', '0.5px');
      mfe.style.pointerEvents = 'none';
      mfe.style.border = 'none';
      mfe.style.padding = '0';
      mfe.style.margin = '0';
      mfe.style.background = 'transparent';
      mfe.style.display = 'flex';
      mfe.style.alignItems = 'center';
      mfe.style.justifyContent = 'center';
      mfe.style.width = '100%';
      mfe.style.height = '100%';
      mfe.addEventListener('click', function (e) {
        var _mfRef$current;

        e.preventDefault();
        e.stopPropagation();
        var event = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        (_mfRef$current = mfRef.current) === null || _mfRef$current === void 0 ? void 0 : _mfRef$current.dispatchEvent(event);
      });
      mfe.style.justifyContent = 'center';
      mfe.style.width = '100%';
      mfe.style.height = '100%';
      mfRef.current.appendChild(mfe);
    }
  }, [latex]);
  return /*#__PURE__*/_jsx("div", {
    className: "latex-symbol-container",
    ref: mfRef
  });
};

export var MathNodeView = function MathNodeView(props) {
  var node = props.node,
      updateAttributes = props.updateAttributes,
      editor = props.editor,
      getPos = props.getPos,
      selected = props.selected;
  var mathfieldRef = useRef(null);
  var mathElementRef = useRef(null);
  var modalMathfieldRef = useRef(null);
  var modalMathElementRef = useRef(null);

  var _useState2 = useState(false),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1];

  var _useState3 = useState(node.attrs.latex || ''),
      tempLatex = _useState3[0],
      setTempLatex = _useState3[1];

  var _useState4 = useState(false),
      showCustomSymbols = _useState4[0],
      setShowCustomSymbols = _useState4[1];

  var handleSelectSymbol = useCallback(function (symbolValue) {
    if (modalMathElementRef.current) {
      modalMathElementRef.current.insert(symbolValue);
      setTempLatex(modalMathElementRef.current.value);
      modalMathElementRef.current.focus();
    }
  }, []);
  var toggleSymbolsView = useCallback(function () {
    setShowCustomSymbols(function (prev) {
      return !prev;
    });

    if (modalMathElementRef.current) {
      setTimeout(function () {
        var _modalMathElementRef$;

        (_modalMathElementRef$ = modalMathElementRef.current) === null || _modalMathElementRef$ === void 0 ? void 0 : _modalMathElementRef$.focus();
      }, 100);
    }
  }, []);
  var openModal = useCallback(function () {
    // Đặt tempLatex trước
    setTempLatex(node.attrs.latex || ''); // Đảm bảo modal được mở

    setIsModalOpen(true);
    setShowCustomSymbols(true); // Delay việc thiết lập mathfield để đảm bảo modal đã được render

    setTimeout(function () {
      if (modalMathfieldRef.current) {
        if (modalMathElementRef.current && modalMathfieldRef.current.contains(modalMathElementRef.current)) {
          modalMathfieldRef.current.removeChild(modalMathElementRef.current);
        }

        var mfe = new MathfieldElement();
        modalMathElementRef.current = mfe;
        mfe.value = node.attrs.latex || '';
        configureMathField(mfe);
        mfe.setAttribute('virtual-keyboard-mode', 'off');

        var handleInput = function handleInput() {
          setTempLatex(mfe.value);
        };

        mfe.addEventListener('input', handleInput); // Ngăn chặn các sự kiện từ mathfield

        mfe.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
        mfe.addEventListener('keydown', function (e) {
          // Ngăn chặn Escape key đóng modal
          if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
          }
        });
        modalMathfieldRef.current.appendChild(mfe); // Delay focus và select all để đảm bảo UI đã render

        setTimeout(function () {
          try {
            mfe.focus();
            setTimeout(function () {
              try {
                mfe.executeCommand('selectAll');
              } catch (e) {
                console.error('Error selecting text:', e);
              }
            }, 200);
          } catch (e) {
            console.error('Error focusing mathfield:', e);
          }
        }, 100);
      }
    }, 50); // Đảm bảo editor vẫn giữ focus khi modal đóng

    return function () {
      if (editor) {
        setTimeout(function () {
          editor.commands.focus();
        }, 50);
      }
    };
  }, [node.attrs.latex, editor]);
  var closeModal = useCallback(function () {
    setIsModalOpen(false); // Dọn dẹp modal math element

    setTimeout(function () {
      try {
        if (modalMathElementRef.current && modalMathfieldRef.current && modalMathfieldRef.current.contains(modalMathElementRef.current)) {
          modalMathfieldRef.current.removeChild(modalMathElementRef.current);
        }
      } catch (e) {
        console.error('Error removing mathfield element:', e);
      }

      modalMathElementRef.current = null; // Đặt focus trở lại editor sau khi đóng modal

      if (editor) {
        setTimeout(function () {
          editor.commands.focus(); // Nếu có vị trí, đặt selection tại node math

          if (typeof getPos === 'function') {
            var pos = getPos();
            editor.commands.setNodeSelection(pos);
          }
        }, 50);
      }
    }, 100);
  }, [editor, getPos]);
  var saveModal = useCallback(function () {
    // Cập nhật attributes với giá trị mới
    updateAttributes({
      latex: tempLatex
    }); // Đóng modal

    closeModal(); // Đảm bảo focus trở lại editor với selection đúng

    if (editor && typeof getPos === 'function') {
      setTimeout(function () {
        editor.commands.focus();
        var pos = getPos();
        editor.commands.setNodeSelection(pos);
      }, 150);
    }
  }, [tempLatex, updateAttributes, closeModal, editor, getPos]);
  useEffect(function () {
    if (!mathfieldRef.current) return;

    if (mathElementRef.current && mathfieldRef.current.contains(mathElementRef.current)) {
      mathfieldRef.current.removeChild(mathElementRef.current);
    }

    var mfe = new MathfieldElement();
    mathElementRef.current = mfe;
    mfe.value = node.attrs.latex || '';
    mfe.style.fontSize = '18px';
    mfe.style.minWidth = '120px';
    mfe.style.width = '100%';
    mfe.style.padding = '4px 8px';
    mfe.setAttribute('read-only', 'true'); // Ngăn chặn sự kiện click từ mathfield để tránh ảnh hưởng đến heading

    mfe.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation(); // Trigger handleClick từ container thay vì từ mathfield

      if (mathfieldRef.current) {
        var clickEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        mathfieldRef.current.dispatchEvent(clickEvent);
      }
    });
    mathfieldRef.current.appendChild(mfe);
    return function () {
      try {
        if (mathElementRef.current && mathfieldRef.current && mathfieldRef.current.contains(mathElementRef.current)) {
          mathfieldRef.current.removeChild(mathElementRef.current);
        }
      } catch (e) {
        console.error('Error cleaning up mathfield element:', e);
      }

      mathElementRef.current = null;
    };
  }, [node.attrs.latex]);
  var handleClick = useCallback(function (e) {
    // Ngăn chặn sự kiện mặc định và lan truyền để tránh heading thoát khỏi chế độ edit
    e.preventDefault();
    e.stopPropagation(); // Tránh mất focus khi đang ở trong heading

    if (editor && typeof getPos === 'function') {
      var pos = getPos(); // Đặt selection trước khi mở modal

      editor.commands.setNodeSelection(pos); // Đảm bảo rằng không có thay đổi focus khác trước khi mở modal

      setTimeout(function () {
        openModal();
      }, 10);
    } else {
      openModal();
    }
  }, [editor, getPos, openModal]);
  var handleDelete = useCallback(function () {
    if (editor && typeof getPos === 'function') {
      editor.commands.deleteNode('math');
    }
  }, [editor, getPos]);
  return /*#__PURE__*/_jsxs(NodeViewWrapper, {
    as: "span",
    children: [/*#__PURE__*/_jsxs(MathContainer, {
      className: selected ? 'selected' : '',
      onClick: handleClick,
      onMouseDown: function onMouseDown(e) {
        e.stopPropagation();
      },
      children: [/*#__PURE__*/_jsx("div", {
        className: "math-actions",
        children: /*#__PURE__*/_jsx("button", {
          className: "math-action-button edit-button",
          onClick: function onClick(e) {
            // Ngăn chặn sự kiện mặc định và lan truyền
            e.preventDefault();
            e.stopPropagation(); // Đảm bảo rằng node vẫn được giữ nguyên trạng thái

            if (editor && typeof getPos === 'function') {
              var pos = getPos();
              editor.commands.setNodeSelection(pos); // Sử dụng setTimeout để tránh xung đột với các sự kiện click khác

              setTimeout(function () {
                openModal();
              }, 10);
            } else {
              openModal();
            }
          },
          children: /*#__PURE__*/_jsx(EditOutlined, {})
        })
      }), /*#__PURE__*/_jsx("div", {
        ref: mathfieldRef
      })]
    }), isModalOpen && /*#__PURE__*/_jsx(MathModal, {
      onClick: function onClick(e) {
        // Chỉ đóng modal khi click vào nền đen, không phải nội dung
        if (e.target === e.currentTarget) {
          e.preventDefault();
          closeModal();
        }
      },
      children: /*#__PURE__*/_jsxs(ModalContent, {
        onClick: function onClick(e) {
          // Ngăn sự kiện lan truyền để tránh đóng modal
          e.stopPropagation();
        },
        children: [/*#__PURE__*/_jsxs(ModalBody, {
          className: "modal-mathfield-container",
          children: [/*#__PURE__*/_jsx(MathfieldContainer, {
            children: /*#__PURE__*/_jsx("div", {
              ref: modalMathfieldRef
            })
          }), showCustomSymbols && /*#__PURE__*/_jsx(MathSymbols, {
            onSelectSymbol: handleSelectSymbol
          })]
        }), /*#__PURE__*/_jsx(ModalFooter, {
          children: /*#__PURE__*/_jsx(SecondaryButton, {
            onClick: saveModal,
            children: 'Confirm'
          })
        })]
      })
    })]
  });
};